import React, { useState, useEffect } from 'react';
import { Row, Col, Card, Tabs } from 'antd';
import NewsFilters from "./NewsFilters";
import useNewsAggregators from './useNewsAggregators';
import { useScreenHeight } from "../../hooks/useScreen";
import { fetchSiteNews } from "../../api/newsApi";
import { useDispatch, useSelector } from 'react-redux';
import { fetchTickerNews } from "../../api/tickersApi";
import NewsList from "./NewsList";
import {
  selectSiteNews,
  selectSiteNewsLoading,
  selectHasMoreSiteNews,
  resetSiteNews
} from '../../store/slices/news.slice';

const { TabPane } = Tabs;
const ARTICLES_PER_PAGE = 5;

const NewsCollection = () => {
  const dispatch = useDispatch();
  const screenHeight = useScreenHeight();
  const [activeTab, setActiveTab] = useState("news");
  const tickerPageIndex = useSelector((state) => state.news.tickerPageIndex);

  const [displayCount, setDisplayCount] = useState(ARTICLES_PER_PAGE * tickerPageIndex);
  const userTickers = useSelector((state) => state.user.data.tickers);

  // Redux state selectors for ticker news
  const keywords = useSelector((state) => state.news.keywords);
  const tickerNews = useSelector((state) => state.news.tickerListNews);

  // Redux state selectors for site news
  const siteNews = useSelector(selectSiteNews);
  const isSiteNewsLoading = useSelector(selectSiteNewsLoading);
  const hasMoreSiteNews = useSelector(selectHasMoreSiteNews);

  const [filteredArticles, setFilteredArticles] = useState(tickerNews);

  const { publishers, groupedBySymbols, filterArticles } = useNewsAggregators(tickerNews);

  useEffect(() => {
    // Update filtered articles whenever tickerNews changes
    setFilteredArticles(tickerNews);
  }, [tickerNews, displayCount]);

  useEffect(() => {
    // Load initial site news when the component mounts
    if (siteNews.length === 0) {
      dispatch(fetchSiteNews());
    }
  }, []);

  const handleTabChange = (key) => {
    setActiveTab(key);
    if (key === 'sites' && siteNews.length === 0) {
      dispatch(fetchSiteNews());
    }
  };

  const handleFilterChange = (criteria) => {
    const newFilteredArticles = filterArticles(criteria);
    setFilteredArticles(newFilteredArticles);
    setDisplayCount(ARTICLES_PER_PAGE); // Reset to initial count when filters change
  };

  const handleLoadMore = () => {
    if (activeTab === 'news') {
      // If we're out of articles, fetch the next batch of ticker news
      dispatch(fetchTickerNews(userTickers));
    } else if (activeTab === 'sites' && !isSiteNewsLoading && hasMoreSiteNews) {
      // Fetch more site news
      dispatch(fetchSiteNews());
    }
  };

  return (
    // <Tabs activeKey={activeTab} onChange={handleTabChange} tabPosition={'right'}>
    //   <TabPane tab="News by Ticker" key="news">
        <Row justify="center" align={'top'} className={'border-t-2 border-gray-100'}>
          <Col flex={'0 0 300px'} className={'px-4 py-8 border-r-2 border-gray-100'}>
            <NewsFilters
              publishers={publishers}
              symbols={Object.keys(groupedBySymbols)}
              onFilterChange={handleFilterChange}
              totalArticles={filteredArticles.length}
            />
          </Col>
          <Col flex={'1'}>
            <div className={'py-10 px-12 mx-auto'}>
              <NewsList
                articles={filteredArticles}
                onLoadMore={handleLoadMore}
                screenHeight={screenHeight}
              />
            </div>
          </Col>
        </Row>
    //   </TabPane>
    //
    // </Tabs>
  );
};

export default NewsCollection;